import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getHashtagCountryDistribution } from '@opm/services';
import { useEffect, useState } from 'react';

export function useHashtagCountryDistribution({ filter }: { filter: any }) {
  const [data, setData] = useState<any>([]);
  const { wrapperCancelRequest, loading } = useCancelRequestHook();

  function request() {
    wrapperCancelRequest(getHashtagCountryDistribution, filter)
      .then(data => {
        const combinedData = Array.isArray(data?.list) ? data.list : [];
        setData(combinedData);
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
  };
}